module.exports = __webpack_public_path__ + "img/qr.ab7f4e18.svg";